import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter"
export default class extends Controller {
  static targets = ["participant"]
  static values = { url: String }

  connect() {
    console.log('filter connected')
    //can be used to limit filters names to max 10
    // this.limitNames()
    this.updateUrl(this.urlValue);
  
  }

  updateUrl(value){
    const url = new URL(location);
    if (value == 'all'){
      url.searchParams.delete("filter")
      history.pushState({}, "", url);
    } else {
     url.searchParams.set("filter", value);
     history.pushState({}, "", url);
    }
  }
    

  limitNames() {
    let names = this.participantTargets
    console.log('limit names to 10')
    if(names.length > 10) {
      let i = 0
      while (i < names.length){
        if (i > 9 ){
          names[i].style.display = "none";
        }
        i++
      }
    }
  }
}
